import React from 'react'
import './styles.scss'

export default ({title, on_cancel, disabled}) => (
  <div className='header'>

    <div>
      <span>{title}</span>
      {
        disabled ? null :
          <button onClick={() => on_cancel()} disabled={disabled}>
            Cancel
          </button>
      }
    </div>

    <div>
      <span>File</span>
      <span>Direction</span>
      <span>Speed</span>
      <span>ETA</span>
      <span>Progress</span>
    </div>
  </div>
)
